import { Study } from '../study';

export class CreatePbaModalPayload {
  study: Study;
}
